import CardCommon from '@op/components/CardCommon';
import ChannelLabel from '@op/components/ChannelLabel';
import UserInfoItem from '@op/components/Snippets/UserInfoItem';
import { dealwithBiLiBiLiImage } from '@op/utils/cdnUrl';
import React, { useMemo } from 'react';
import { Badge, H4 } from 'tea-component';
import './index.scss';
import RenderImg from '@op/components/RenderImg';
import { useStreamingDetailAutoAI } from '../../../hooks/useStreamingDetail';
import { DefaultImg } from '@op/constants/defaultImg';
import { IRealtimeStreamingDetail } from '../../../type';
import useLanguage from '@op/hooks/useLanguage';

export default function ({
  data,
  hasStreaming,
  addRefreshTask,
  setHideContentAnalysis
}: {
  data: IRealtimeStreamingDetail;
  hasStreaming: boolean;
  addRefreshTask: (key: string, callback: () => Promise<void>) => void;
  setHideContentAnalysis?: (hide: boolean) => void;
}) {
  const { formatMessage } = useLanguage();
  const {
    live_title,
    live_time,
    live_anchors,
    anchors_image,
    source,
    user_cover,
    kol_types,
  } = useMemo(() => {
    const { ext_json } = data || {};

    let streamingInfo: { user_cover?: string } = {};

    try {
      const firstParse = JSON.parse(ext_json || '{}');
      streamingInfo = JSON.parse(firstParse || '{}') || firstParse;
    } catch (error) { }

    return { ...(data || {}), ...streamingInfo };
  }, [data]);

  const { content, time } = useStreamingDetailAutoAI({
    id: data?.live_id,
    needRequest: hasStreaming,
    addRefreshTask,
    liveTime: data?.live_time,
    setHideContentAnalysis
  });

  return (
    <CardCommon hoverNoShadow className="dbo-streaming-detail-wrapper">
      <>
        <div className="dbo-streaming-detail-info">
          <RenderImg
            className={`dbo-streaming-detail-img dbo-videobox-cover`}
            coverImage={dealwithBiLiBiLiImage(anchors_image!)}
            defaultImage={DefaultImg.VIDEO}
          ></RenderImg>
          <div className="dbo-streaming-detail">
            <H4>{live_title}</H4>
            <UserInfoItem
              isLink={false}
              icon={user_cover!}
              name={live_anchors!}
            >
              {() => {
                return (
                  <>
                    {(kol_types || []).includes('featured') && (
                      <Badge theme="success" className="dbo-steaming-tags">
                        {formatMessage('Featured')}
                      </Badge>
                    )}
                  </>
                );
              }}
            </UserInfoItem>
            <ChannelLabel
              replaceText={`${formatMessage(
                'Live Stream Start Time',
              )}：${live_time}`}
              channel_name={source as 'steam'}
            ></ChannelLabel>
          </div>
        </div>
        {hasStreaming && content && (
          <CardCommon
            title={
              <div className="dbo-streaming-detail-ai-title">
                <img src={DefaultImg.AI} />
                <span>
                  {/* {time}  */}
                  {formatMessage('Real-Time AI Summary')}
                </span>
                <span className="dbo-streaming-detail-ai-subtitle">
                  {formatMessage('(Refreshed Every 30 Mins)')}
                </span>
              </div>
            }
            empty={!content}
            hasEmptyImg={false}
            emptyHeight={44}
            emptyTitleText={'No summary available yet'}
            emptyDescText={
              'The system will refresh automatically every 30 minutes until the live stream ends'
            }
            hoverNoShadow
            className="dbo-streaming-detail-ai"
          >
            <div className="dbo-streaming-detail-ai-content">{content}</div>
          </CardCommon>
        )}
      </>
    </CardCommon>
  );
}
